import type { ReactNode } from 'react';

export const symbol_currency_rupee_circle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M567-269q10-9 10.5-22t-8.5-23L453-438l1-3h5q53 0 91.5-30t46.5-80h16q10 0 16.5-7t6.5-17q0-10-6.5-16.5T613-598h-17q-3-15-10-29t-16-26h43q10 0 16.5-7t6.5-17q0-10-7-16.5t-17-6.5H347q-10 0-16.5 7t-6.5 17q0 10 7 16.5t17 6.5h108q34 0 53.5 15t26.5 40H347q-10 0-16.5 7t-6.5 17q0 10 6.5 16.5T347-551h189q-5 26-25.5 42.5T453-492h-67q-10 0-17.5 5T358-474q-3 8-2.5 16t7.5 16l158 172q9 10 22.5 10t23.5-9ZM480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-156t86-127Q252-817 325-848.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 82-31.5 155T763-197.5q-54 54.5-127 86T480-80Zm0-60q142 0 241-99.5T820-480q0-142-99-241t-241-99q-141 0-240.5 99T140-480q0 141 99.5 240.5T480-140Zm0-340Z"
		/>
	</svg>
);
